import { ROUTE_DASHBOARD_PRICING_POLICIES_DETAILS } from '@/constants/routes';
import HeaderTemplate from '@/templates/Header.template';
import PageSectionTemplate from '@/templates/PageSection.template';
import { IPricingPolicy } from '@/types/pricing-policy';
import { Box, Button, ButtonGroup, Card, CardBody, IconButton, Text, Tooltip, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { FiEdit, FiPlus, FiTrash } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { usePricingPolicyList } from './pricing-policy-list.controller';

export default function PricingPoliciesListPage() {
	const { query, handleCreatePolicyClick, handleRemovePricingPolicyClick } = usePricingPolicyList();

	if (!query.data?.items) {
		return null;
	}

	return (
		<PageSectionTemplate>
			<HeaderTemplate
				left={<></>}
				center={t('Pricing policies')}
				right={
					<Button colorScheme="primary" size="sm" onClick={handleCreatePolicyClick} rightIcon={<FiPlus />}>
						{t('Create')}
					</Button>
				}
			/>
			<VStack w="full" mt={4}>
				{query.data.items.map(p => {
					return <PricePolicyItem onDeleteClick={() => handleRemovePricingPolicyClick(p.id)} key={p.id} policy={p} />
				})}
			</VStack>
		</PageSectionTemplate>
	);
}

function PricePolicyItem(props: { policy: IPricingPolicy, onDeleteClick: () => void }) {
	const history = useHistory();

	return (
		<Card w="full" shadow="none" borderColor="gray.200" borderWidth={1} p={0}>
			<CardBody display="grid" gridTemplateColumns="1fr auto" alignItems="center" py={3}>
				<Text>{props.policy.name}</Text>
				<Box display="flex" justifyContent="flex-end">
					<ButtonGroup isAttached variant="outline">
						<Tooltip label={t('Delete')}>
							<IconButton onClick={props.onDeleteClick} aria-label={t('Delete')} icon={<FiTrash />} />
						</Tooltip>

						<Tooltip label={t('Edit')}>
							<IconButton
								onClick={() => {
									history.push(ROUTE_DASHBOARD_PRICING_POLICIES_DETAILS.replace(':id', props.policy.id));
								}}
								aria-label={t('Edit')}
								icon={<FiEdit />}
							/>
						</Tooltip>
					</ButtonGroup>
				</Box>
			</CardBody>
		</Card>
	);
}
